import { useLocation } from "react-router-dom";
import CommentDetail from "@/pages/CommentDetail/CommentDetail";

const PostWrapper = () => {
  const location = useLocation();
  return <CommentDetail key={location.key} />;
};

export default PostWrapper;
